import React from 'react';
import { Stack } from '@mui/material';
import {
  TripRequestChips,
  TravelerTagChips,
  OtherChips,
} from '@marageti/z4-lib';
import { ReferralType, TripRequest, TripRequestStatus } from '@marageti/z4-sdk/lib/travel';
import { TravelerTags } from '@marageti/z4-sdk/lib/people';
import { useAuthStore } from '../../store';
import { getChipsFromTripRequest } from '../../utils/chips';

const {
  ChipPending,
  ChipVerified,
  ChipPostponed,
  ChipCanceled,
  ChipJunk,
  ChipMatched,
  ChipReferred,
  ChipSold,
} = TripRequestChips;
const {
  ChipVIP,
  ChipRedFlag,
  ChipBadApple,
  ChipTravelAgent,
  ChipJunk: ChipJunkTraveler,
  ChipFOBY,
} = TravelerTagChips;
const { ChipPRL, ChipRepeat } = OtherChips;

const TripRequestChipList = ({
  tripRequest = undefined,
}: {
  tripRequest?: TripRequest,
}) => {
  const { loggedInTeamMember } = useAuthStore();

  if (!tripRequest) {
    return null;
  }

  const chips = getChipsFromTripRequest(tripRequest);

  return (
    <Stack
      direction="row"
      spacing={0.5}
    >
      {chips.map((chip: string) => {
        switch (chip) {
          case TripRequestStatus.PendingStatus:
            return <ChipPending key={chip} />;
          case TripRequestStatus.VerifiedStatus:
            return <ChipVerified key={chip} />;
          case TripRequestStatus.PostponedStatus:
            return <ChipPostponed key={chip} />;
          case TripRequestStatus.MatchedStatus:
            return <ChipMatched key={chip} />;
          case TripRequestStatus.SoldStatus:
            return <ChipSold key={chip} />;
          case TripRequestStatus.CanceledStatus: {
            const { updatedBy } = tripRequest.statusInfo;
            const { id: tmId } = loggedInTeamMember!;
            const { id } = tripRequest.travelers[0];
            if (updatedBy === tmId) return <ChipCanceled label="Canceled" key={chip} />;
            if (updatedBy === id) return <ChipCanceled label="Traveler Canceled" key={chip} />;
            return <ChipCanceled key={chip} />;
          }
          case TripRequestStatus.JunkStatus:
            return <ChipJunk key={chip} />;
          case TripRequestStatus.ReferredStatus:
            return <ChipReferred key={chip} />;
          case TravelerTags.VIP:
            return <ChipVIP key={chip} />;
          case TravelerTags.BAD_APPLE:
            return <ChipBadApple key={chip} />;
          case TravelerTags.RED_FLAG:
            return <ChipRedFlag key={chip} />;
          case TravelerTags.TRAVEL_AGENT:
            return <ChipTravelAgent key={chip} />;
          case TravelerTags.JUNK:
            return <ChipJunkTraveler key={chip} />;
          case ReferralType.OneTimePartnerReferral:
          case ReferralType.LifetimePartnerReferral:
            return <ChipPRL key={chip} />;
          case 'REPEAT_TRAVELER':
            return <ChipRepeat key={chip} />;
          case TravelerTags.FOBY:
            return <ChipFOBY key={chip} />;
          default:
            return null;
        }
      })}
    </Stack>
  );
};

export default TripRequestChipList;
